import { Navigate } from 'react-router-dom';
import adminAuthService from '../services/adminAuthService';

const AdminProtectedRoute = ({ children, allowPackagingAdmin = false, allowInventoryAdmin = false, allowedRoles = null }) => {
  // Check if admin is authenticated using JWT
  const isAuthenticated = adminAuthService.isAuthenticated();
  const isAdmin = adminAuthService.isAdmin();
  
  console.log('AdminProtectedRoute: isAuthenticated:', isAuthenticated, 'isAdmin:', isAdmin);
  
  if (!isAuthenticated || !isAdmin) {
    // Admin is not authenticated, redirect to admin login
    console.log('AdminProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/admin/login" replace />;
  }

  // Check if user is packaging admin
  const currentUser = adminAuthService.getCurrentUser();
  const isPackagingAdmin = currentUser && currentUser.role === 'packaging_admin';
  const isInventoryAdmin = currentUser && currentUser.role === 'inventory_admin';

  console.log('AdminProtectedRoute: User role:', currentUser?.role, 'allowPackagingAdmin:', allowPackagingAdmin, 'allowInventoryAdmin:', allowInventoryAdmin, 'allowedRoles:', allowedRoles);
  
  // If allowedRoles is specified, check if user has one of the allowed roles
  if (allowedRoles && !allowedRoles.includes(currentUser?.role)) {
    console.log('AdminProtectedRoute: User role not in allowedRoles, redirecting to dashboard');
    return <Navigate to="/admin/dashboard" replace />;
  }

  // If packaging admin is trying to access non-allowed page, redirect to packaging
  if (isPackagingAdmin && !allowPackagingAdmin) {
    console.log('AdminProtectedRoute: Packaging admin blocked, redirecting to /admin/packaging');
    return <Navigate to="/admin/packaging" replace />;
  }

  // If inventory admin is trying to access non-allowed page, redirect to missing products
  if (isInventoryAdmin && !allowInventoryAdmin) {
    console.log('AdminProtectedRoute: Inventory admin blocked, redirecting to /admin/missing-products');
    return <Navigate to="/admin/missing-products" replace />;
  }

  console.log('AdminProtectedRoute: Access granted');
  // Admin is authenticated, render the protected component
  return children;
};

export default AdminProtectedRoute;
